import { Component, OnInit } from '@angular/core';
import { createInvoicingMockData } from './invoicing.mock';
import { Deviation, InvoicesListItem, Summary } from './types';

@Component({
  selector: 'dashboard-invoicing',
  templateUrl: './invoicing.component.html',
  styleUrls: ['./invoicing.component.scss']
})
export class DashboardInvoicingComponent implements OnInit {
  summary: Summary = {
    invoiceable: { receiptCount: 0, amount: 0 },
    totals: { count: 0, totalPrice: 0 },
    paid: { count: 0, totalPrice: 0 },
    outstanding: { count: 0, totalPrice: 0 },
    overdue: { count: 0, totalPrice: 0 }
  }

  deviations: Deviation[] = []
  list: InvoicesListItem[] = []

  constructor() { }

  ngOnInit(): void {
    const mockData = createInvoicingMockData();
    this.summary = mockData.summary;
    this.deviations = mockData.deviations;
    this.list = mockData.list;
  }

}
